
<nav class="navbar bg-body-tertiary m-4">
    <div class="container d-flex justify-content-start">
      <a class="navbar-brand" href="#">
        <img src="assets/images/Logo_Mxns_Without_Background.png" alt="Bootstrap">
      </a>
      <h1>Questionario registrazione volontario</h1>
    </div>
  </nav>